import React, { } from "react";
import "./index.scss";

const App = (props) => {
    if (props.note) {
        return props.note
    }
    return (
        <div className="meeting-note">
            {props.e}
            <br />
            {props.c}
            <br />
            <br />
            {props.note_e || ""}
            <br />
            {props.note_c || ""}
        </div>
    )
}

export default App 


// WEBPACK FOOTER //
// ./src/components/table/meetingFlash/Note.js